import { WorkshopForm } from "../../components/Forms/WorkshopForm";

export const NewWorkshop = () => {
  return (
    <div className="p-card gap-4 p-3 align-self-center">
      <h1 className="text-center text-3xl">Crear Taller</h1>
      <WorkshopForm />
    </div>
  );
};
